<script lang="ts">
    import { breadcrumbs } from "../../store"
    import SubdirectoryArrowRightIcon from "svelte-material-icons/SubdirectoryArrowRight.svelte"
    import { langField } from "../../i18n"

    export let level: number
    export let nodes: CategoryNode[]
</script>

<ul>
    {#each nodes as node}
        <li class:active="{node == $breadcrumbs[level]}">
            <a href="{langField(node.path, '')}"
                ><span class="icon"
                    ><SubdirectoryArrowRightIcon size="18px" /></span
                ><span class="text">{langField(node.name, "")}</span></a
            >
            {#if node.childObjects?.length}
                <svelte:self nodes="{node.childObjects}" level="{level + 1}" />
            {/if}
        </li>
    {/each}
</ul>
